/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { CurrencyPositioningType } from "@insite/client-framework/Types/ApiModels";
import React, { FC } from "react";
import { connect } from "react-redux";

interface OwnProps {
    amount: number;
    currencySymbol?: string;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    language: state.context.session.language,
    currencySymbol: ownProps.currencySymbol ?? state.context.session.currency?.currencySymbol,
    // set server side from the bill-to "ThreeDecimalPricing" custom property
    maxFractionDigits: state.context.session.properties?.threeDecimalPricing === "true" ? 3 : 2,
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

// mirrors getLocalizedCurrency but honors the customer's 3-decimal pricing flag
const LocalizedCurrency: FC<Props> = ({ amount, language, currencySymbol, maxFractionDigits }) => {
    if (!language || !currencySymbol) {
        return null;
    }

    const options: Intl.NumberFormatOptions = {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: maxFractionDigits,
    };
    let currencyFormatter;
    try {
        currencyFormatter = new Intl.NumberFormat(language.cultureCode || language.languageCode, options);
    } catch {
        currencyFormatter = new Intl.NumberFormat(undefined, options);
    }

    const negativeSymbol = amount < 0 ? "-" : "";
    const amountWithoutNegativeSign = currencyFormatter.format(Math.abs(amount));

    return (
        <>
            {language.currencyPositioning === CurrencyPositioningType.Left
                ? `${negativeSymbol}${currencySymbol}${amountWithoutNegativeSign}`
                : `${negativeSymbol}${amountWithoutNegativeSign}${currencySymbol}`}
        </>
    );
};

export default connect(mapStateToProps)(LocalizedCurrency);
